module.exports = __webpack_public_path__ + "img/654.56faebe7.jpg";